import { dropBoolean } from 'utils/drops';

const getGrupoProdutoFilterFields = () => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'grupo', label: 'Grupo' },
  { name: 'descricao', label: 'Descrição', initial: true },
  { name: 'ativo', label: 'Ativo', type: 'select', options: dropBoolean },
];

export default getGrupoProdutoFilterFields;
